import { StatusCode } from '@/modules/asset/constants';
import { computed, Ref } from '@vue/composition-api';

export function useAssetStatus(status: Ref<StatusCode | undefined>) {
    const label = computed(() => {
        switch (status.value) {
            case StatusCode.Internal:
                return 'Pending Publication';
            case StatusCode.Pending:
                return 'Pending Approval';
            default:
                return status.value;
        }
    });

    const statusClass = {
        [StatusCode.Incomplete]: 'text-yellow-700 bg-yellow-100 border-yellow-200',
        [StatusCode.Uploading]: 'text-purple-700 bg-purple-200 border-purple-200',
        [StatusCode.Updating]: 'text-blue-700 bg-blue-100 border-blue-200',
        [StatusCode.Deleted]: 'text-red-700 bg-red-200 border-red-200',
        [StatusCode.Available]: 'text-green-800 bg-green-200 border-green-200',
        [StatusCode.Internal]: 'text-green-700 bg-green-100 border-green-200',
        [StatusCode.Pending]: 'text-green-700 bg-green-100 border-green-200',
        [StatusCode.Archived]: 'text-neutral-700 bg-neutral-100 border-neutral-200',
    };

    const colour = computed(() => (status.value ? statusClass[status.value] : 'text-yellow-700 bg-yellow-100'));

    const icon = computed(() => null);

    const iconColour = computed(() => {
        switch (status.value) {
            case StatusCode.Incomplete:
                return 'text-yellow-700';
            case StatusCode.Uploading:
                return 'text-purple-700';
            case StatusCode.Updating:
                return 'text-blue-700';
            case StatusCode.Deleted:
                return 'text-red-700';
            case StatusCode.Available:
            default:
                return 'text-yellow-700';
        }
    });

    const tooltip = computed(() => {
        switch (status.value) {
            case StatusCode.Internal:
                return 'The dataset can be viewed by organisation members only; the process to ensure the consent of input dataset provider(s), for publication in the Data Market has not started yet.';
            case StatusCode.Pending:
                return 'The process for publishing in the Data Market has started yet some derivation contracts have not been yet finalized.';
            default:
                return null;
        }
    });

    return { label, colour, icon, iconColour, statusClass, tooltip };
}
